import * as types from "./types";
import * as mutation_types from "./mutation_types";
import {
    GDSTariff,
    RebuildFlight,
    TourSearchForMap
} from "./api/methods";

import Vue from 'vue'
import { bus } from '../../../main'
// import {gds} from './mock3.js'

export default {
    [types.A_CALCULATE_TOUR] ( context, payload ) {
        return new Promise((resolve, reject) => {
            Vue.Api.Post(`${context.state.API_URL}CalculateReservation`, payload)
                .then(res => {
                    let err = res.data.ErrorMessage;
                    if(err.length){
                        reject(err)
                    }
                    resolve(res.data)
                });
        });
    },
    [types.A_BUY_TOUR] ( context, payload ) {
        return new Promise((resolve, reject) => {
            Vue.Api.Put(`${context.state.API_URL}CreateReservation/1`, payload)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                });
        });
    },
    [types.A_BUY_TOUR_NO_REGISTRATION] ( context, payload ) {
      return new Promise((resolve, reject) => {
          Vue.Api.Put(`${context.state.API_URL}CreateReservationNoRegistration/1`, payload)
            .then((res) => {
              resolve(res.data);
            })
            .catch((err) => {
              reject(err);
            });
        
      });
    },
    [types.A_CHECK_DOUBLE_DOGOVOR] ( context, payload ) {
        return new Promise((resolve, reject) => {
            Vue.Api.Post(`${context.state.API_URL}CheckDoubleDogovor`, payload)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                });
        });
    },
    [types.A_SET_TOUR] ( context, payload ) {
        let data = payload
            .replace("?gtm_debug=x", "") // временный код
            .split("?")[1]
            .split("&");

        let currencyIsoCode = data.find(x => x.includes("currency")).split("=")[1];
        let currency = this.getters['getAllCurrency'].find(x => x.IsoCode === decodeURIComponent(currencyIsoCode)).Code

        const dCity = data.find(x => x.includes("departureCities")).split("=")[1];
        const destType = data.find(x => x.includes("destination")).split("=")[1].split("_")[0];
        const destanation = data.find(x => x.includes("destination")).split("=")[1].split("_")[1];
        const dates = data.find(x => x.includes("date")).split("=")[1];
        const durations = data.find(x => x.includes("duration")).split("=")[1];
        const adult = data.find(x => x.includes("adultCount")).split("=")[1];
        let childrens = data.find(x => x.includes("childAges"));
        childrens = childrens ? childrens.split("=")[1].split(",") : null;
        const hotelQ = data.find(x => x.includes("hotelQuota"))?.split("=")[1];
        const aviaQ = data.find(x => x.includes("aviaQuota")).split("=")[1];
        const busQ = data.find(x => x.includes("busTransferQuota"))?.split("=")[1];
        const railwayQ = data.find(x => x.includes("trainTransferQuota"))?.split("=")[1];
        let hotelScheme = data.find(x => x.includes("hotelScheme")).split("=")[1];
        if (hotelScheme) {
            hotelScheme = hotelScheme.split(",");
            hotelScheme = hotelScheme.map(x => {
                let item = x.split("_");
                return {
                    "TemplateId": item[0],
                    "DurationInNight": item[1],
                    "Code": item[2],
                    "PacketKey": item[3],
                    "PartnerKey": item[4],
                    "GDSProviderId": item[5],
                    "TotalTourDuration": item[6],
                }
            });
        } else {
            hotelScheme = [];
        }
        hotelScheme = JSON.stringify(hotelScheme);
        const tour = data.find(x => x.includes("tour")).split("=")[1];
        const date = new Date().getTime();

        let sendParams = `${context.state.API_URL}TourForWeb/search/simple?` +
            `DepartureCityKeys=${dCity}&` +
            `DestinationType=${destType}&` +
            `DestinationKey=${destanation}&` +
            `Dates=${dates}&` +
            `Durations=${durations}&` +
            `AdultCount=${adult}&` +
            (childrens ? childrens.map(x => `ChildAges=${x}&`).join("") : "") +
            `CurrencyName=${currency}&` +
            `HotelQuota=${hotelQ}&` +
            `AviaQuota=${aviaQ}&` +
            `BusTransferQuota=${busQ}&` +
            `RailwayTransferQuota=${railwayQ}&` +
            `HotelScheme=${hotelScheme}&` +
            `TourKey=${tour}&` +
            `TourDuration=${durations}&` +
            `PageNumber=1&PageSize=20&IsFromBasket=true&isFillSecondaryFilters=false&RemoteHotelMode=1&` +
            `_=${date}`;

        // context.state.tourSearchParams = sendParams;
        // sendParams = encodeURI(sendParams)
        return new Promise((resolve) => {
            Vue.Api.Get(sendParams)
                .then(res => {
                    resolve(res.data)
                });
        });
    },
    [types.A_GET_MANAGERS] ( context, payload ) {
        const date = new Date().getTime();
        let managers = payload.data.map(x => `ids=${x}`).join("&");
        let sendParam = `${context.state.API_URL}Users?${managers}&_=${date}`;
        if (payload.branche) {
            sendParam = `${context.state.API_URL}Users?${managers}&branchKey=${payload.branche}&_=${date}`;
        }

        // sendParam = encodeURI(sendParam)
        return new Promise((resolve) => {
            Vue.Api.Get(sendParam)
                .then(res => {
                    resolve(res.data)
                });
        });
    },
    [types.A_GET_BRANCHES] ( context, payload ) {
        const date = new Date().getTime();
        let branches = payload.map(x => `ids=${x}`).join("&");

        return new Promise((resolve) => {
            Vue.Api.Get(`${context.state.API_URL}Branches?${branches}&cityKey=0&_=${date}`)
                .then(res => {
                    resolve(res.data)
                });
        });
    },
    [types.A_GET_TOURIST_DATA] ( context, payload ) {
        const date = new Date().getTime();

        let sendParams = `${context.state.API_URL}TouristDataSettings?countryId=${payload}&_=${date}`;

        // sendParams = encodeURI(sendParams)
        return new Promise((resolve) => {
            Vue.Api.Get(sendParams)
                .then(res => {
                    resolve(res.data)
                });
        });
    },
    [types.A_ADDITIONAL_HOTEL_SERVICES] ( context, payload ) {
        return new Promise((resolve, reject) => {
            Vue.Api.Post(`${context.state.API_URL}GetHotelsAdditionalServices`, payload)
                .then(res => {
                    resolve(res.data)
                })
                .catch(e => {
                    reject(e)
                })
        });
    },
    [types.A_SET_TOUR_INFO] ( context, payload ) {
        context.commit(mutation_types.M_SET_TOUR_INFO, payload)
    },
    [types.A_GET_FLIGHTS_SEQUENCIES] ( context, payload ) {
        let params = payload.params;
        let changePage = payload.changePage || false;
        let classChange = payload.classChange || false;
        let loadingText = payload.loadingText || "";


        const page = params.page;
        let flightsSequencies = context.state.flightsSequencies.slice();

        if (!changePage) {
            if (classChange) {
                bus.$emit("page-load", true);
                setTimeout(() => {
                    bus.$emit("page-load-text", loadingText);
                },100);
                let data = Object.assign({}, context.state.GDSData);
                data.filterTariff = params.class;
                context.state.saveParams = Object.assign({}, params);
                return new Promise((resolve, reject) => {
                    this.dispatch("basket/A_GET_GDS_FLIGHT", data)
                        .then(res => {
                            bus.$emit("page-load", false);
                            resolve(res)
                        })
                        .catch(() => {
                            reject()
                        })
                })
            }
            context.state.saveParams = null;

            const sort = params.sort;
            if (sort === "cheap") { //Сначала дешевые
                flightsSequencies = this.getters['quicksort'](flightsSequencies, "price")
            } else if (sort === "fast") { //Сначала быстрые
                flightsSequencies = this.getters['basket/fastSort'](flightsSequencies, "timeForward")
            } else if (sort === "optimal") { //Сначала оптимальные
                flightsSequencies = this.getters['quicksort'](flightsSequencies, "rating").reverse()
            }

            const direct = params.direct;
            flightsSequencies = flightsSequencies.filter(x => {
                //филтруем по пересадкам
                const directToCount = x.flights.filter(x2 => x2.direction === 1).length
                const directBackCount = x.flights.filter(x2 => x2.direction === 2).length
                if (direct === "twoOrMoreDirect" && (directToCount > 2 && directBackCount > 2)) {
                    return x
                } else if (direct === "oneDirect" && (directToCount === 2 && directBackCount === 2)) {
                    return x
                } else if (direct === "withoutDirect" && (directToCount === 1 && directBackCount === 1)) {
                    return x
                } else if (direct === "all") {
                    return x
                }
            });


            const luggageFilter = params.luggage;
            if (luggageFilter !== 'all') {

                flightsSequencies = flightsSequencies.filter(x => {
                    //филтруем по багажу
                    let isInclude = false;
                    for (let i = 0; i < x.flights.length; i++) {
                        let luggageFlights = x.flights[i].segments[0].filterLuggageValue[0];
                        if (luggageFilter.toLowerCase() == luggageFlights.toLowerCase()) {
                            isInclude = true;
                        } else {
                            isInclude = false;
                            break;
                        }
                    }
                    if (isInclude) {
                        return x
                    }
                });
            }
            const connectionLimit = params.connectionLimit.slice();
            flightsSequencies = flightsSequencies.filter(x => {
                //филтруем по "Длительность пересадок"
                return x.maxConnectionTime >= connectionLimit[0] && x.maxConnectionTime <= connectionLimit[1]
            });

            const toTimeLimit = params.toTimeLimit.slice();
            const backTimeLimit = params.backTimeLimit.slice();
            flightsSequencies = flightsSequencies.filter(x => {
                //филтруем по времени в пути
                let isBackDirection = x.flights.find(x2 => x2.direction === 2);
                if (
                    isBackDirection &&
                    x.timeForward >= toTimeLimit[0] && x.timeForward <= toTimeLimit[1] &&
                    x.timeBackward >= backTimeLimit[0] && x.timeBackward <= backTimeLimit[1]
                ) {
                    return x
                } else if (
                    !isBackDirection &&
                    x.timeForward >= toTimeLimit[0] && x.timeForward <= toTimeLimit[1]
                ) {
                    return x
                }
            });
            const toDepartureTime = params.toDepartureTime.slice();
            const toArrivalTime = params.toArrivalTime.slice();
            const backDepartureTime = params.backDepartureTime.slice();
            const backArrivalTime = params.backArrivalTime.slice();
            flightsSequencies = flightsSequencies.filter(x => {
                //филтруем по времени
                let isBackDirection = x.flights.find(x2 => x2.direction !== 1);

                let toTimeStart = x.flights.find(x2 => x2.direction === 1).segments[0].departureDate;
                toTimeStart = this.getters['basket/timeToMinuts'](toTimeStart.split("T")[1]);
                let toTimeEnd = x.flights.filter(x2 => x2.direction === 1);
                toTimeEnd = toTimeEnd[toTimeEnd.length - 1].segments[0].arrivalDate;
                toTimeEnd = this.getters['basket/timeToMinuts'](toTimeEnd.split("T")[1]);

                if (isBackDirection) {
                    let backTimeStart = x.flights.find(x2 => x2.direction === 2).segments[0].departureDate;
                    backTimeStart = this.getters['basket/timeToMinuts'](backTimeStart.split("T")[1]);
                    let backTimeEnd = x.flights.filter(x2 => x2.direction === 2);
                    backTimeEnd = backTimeEnd[backTimeEnd.length - 1].segments[0].arrivalDate;
                    backTimeEnd = this.getters['basket/timeToMinuts'](backTimeEnd.split("T")[1]);

                    if (
                        // toTimeStart >= toDepartureTime[0] && toTimeStart <= toDepartureTime[1] &&
                        // toTimeEnd >= toArrivalTime[0] && toTimeEnd <= toArrivalTime[1] &&
                        backTimeStart >= backDepartureTime[0] && backTimeStart <= backDepartureTime[1] &&
                        backTimeEnd >= backArrivalTime[0] && backTimeEnd <= backArrivalTime[1] &&
                        toTimeStart >= toDepartureTime[0] && toTimeStart <= toDepartureTime[1] &&
                        toTimeEnd >= toArrivalTime[0] && toTimeEnd <= toArrivalTime[1]                      
                    ) {
                            return x
                    }
                } else {
                    if (
                        toTimeStart >= toDepartureTime[0] && toTimeStart <= toDepartureTime[1] &&
                        toTimeEnd >= toArrivalTime[0] && toTimeEnd <= toArrivalTime[1]
                    ) {
                        return x
                    }
                }
            });
            const someIncludes = (arr1, arr2) => {
                return arr2.some(x => arr1.includes(x))
            }
            const departureAirportList = params.departureAirportList.slice().map(x => x.value);
            flightsSequencies = flightsSequencies.filter(x => {
                //филтруем по аэропорту вылета и прилета
                let isBackDirection = x.flights.find(x2 => x2.direction === 2);

                let departureAirports = x.flights
                    .map(x2 => x2.segments[0].departureAirport.mtItem.code);

                if (isBackDirection) {
                    const arrivalAirportList = params.arrivalAirportList.slice().map(x => x.value);
                    let arrivalAirports = x.flights
                        .map(x2 => x2.segments[0].arrivalAirport.mtItem.code);

                    if (
                        someIncludes(departureAirportList, departureAirports) &&
                        someIncludes(arrivalAirportList, arrivalAirports)
                    ) {
                        return x
                    }
                } else {
                    if (someIncludes(departureAirportList, departureAirports)) {
                        return x
                    }
                }
            });
            const directsPlaceList = params.directsPlaceList.slice().map(x => x.value);
            
            if(directsPlaceList.length>0)
            {
                flightsSequencies = flightsSequencies.filter((x) => {
                    //филтруем по аэропорту пересадки
                    let departureAirport = x.flights.map(x2 => x2.segments[0].departureAirport.mtItem.code);

                    let isInclude = false;
                    departureAirport.forEach(x2 => {
                        if (directsPlaceList.includes(x2)) {
                            isInclude = true;
                        }
                    });

                    let isBackDirection = x.flights.find(x2 => x2.direction === 2);
                    if (isBackDirection) {
                        if (x.flights.length === 2) {
                            isInclude = true
                        }
                    } else {
                        if (x.flights.length === 1) {
                            isInclude = true
                        }
                    }
                    if (isInclude) {
                        return x
                    }
                });
            }

            const airlineList = params.airlineList.slice().map(x => x.value);
            flightsSequencies = flightsSequencies.filter(x => {
                //филтруем по авиокомпании
                let isInclude = false;
                for (let i = 0; i < x.flights.length; i++) {
                    let airline = x.flights[i].segments[0].airline.mtItem.code;
                    if (!airlineList.includes(airline)) {
                        isInclude = false;
                        break;
                    } else {
                        isInclude = true;
                    }
                }
                if (isInclude) {
                    return x
                }
            });
        }
        if (changePage) {
            flightsSequencies = context.state.flightsFiltred.slice();
        } else {
            context.state.flightsFiltred = flightsSequencies.slice();
        }


        // Group by price
        const flightsSequenciesGroupByPrice = []
        flightsSequencies.forEach(x => {
            x.price = x.deltaPrice.amount;
            x.hasLuggage = context.getters['getLuggage'](x);
            x.timeLimit = x.flights[0].segments[0].timeLimit;
            x.flightId = x.flights[0].remotePriceSource.flightId

            const index = flightsSequenciesGroupByPrice.map(x2 => x2?.group[0].price).indexOf(x.price);
            if (index !== -1) {
                flightsSequenciesGroupByPrice[index].group.push(x)
            } else {
                flightsSequenciesGroupByPrice.push({
                    group: [x],
                    ...x
                })
            }
            return x
        });

        const flightsSequenciesMutate = flightsSequenciesGroupByPrice.map(x => {
            const result = []
            x.group.forEach(x2 => {
                const item = {
                    id: x2.flights[0].remotePriceSource.flightId,
                    flights: ['', ''] // 0 -> forward, 1 -> backward
                }
                x2.flights.forEach(x3 => {
                    x3.segments.forEach(x4 => {
                        const index = x4.direction === 'Forward' ? 0 : 1
                        item.flights[index] += JSON.stringify(x4)
                    })
                })
                result.push(item)
            })
            return result
        })

        // Group if same includes
        const groupIfSameIncludes = []
        flightsSequenciesMutate.forEach(x => {
            const group = []
            x.forEach(x2 => {
                let index = -1
                x2.flights.forEach(x3 => {
                    group.forEach((x4, i4) => {
                        x4.forEach(x5 => {
                            if (x5.flights.includes(x3)) index = i4
                        })
                    })
                })
                if (index !== -1) {
                    group[index].push(x2)
                    return
                }
                group.push([x2])
            })
            groupIfSameIncludes.push(group)
        })

        // Filter if every include
        let filterIfEveryInclude = []
        groupIfSameIncludes.forEach(x => {
            const group = []
            x.forEach(x2 => {
                const helper = {}
                x2.forEach(x3 => {
                    const forward = x3.flights[0]
                    if (helper[forward]) {
                        helper[forward].ids.push(x3.id)
                        helper[forward].backwards += x3.flights[1]
                        return
                    }
                    helper[forward] = {
                        ids: [x3.id],
                        backwards: x3.flights[1]
                    }
                })
                const helper2 = [];
                for (const key in helper) {
                    const item = helper[key]
                    const index = helper2.map(x => x.backwards).indexOf(item.backwards)
                    if (index !== -1) {
                        helper2[index].ids.push(...item.ids)
                    } else {
                        helper2.push({
                            ids: item.ids,
                            backwards: item.backwards
                        })
                    }
                }
                group.push(helper2.map(x3 => x3.ids))
            })
            filterIfEveryInclude.push(group)
        })

        filterIfEveryInclude = filterIfEveryInclude.flat(2)

        const mutateToFlightsSequencies = []
        filterIfEveryInclude.forEach(x => {
            const group = []
            x.forEach(x2 => {
                const flight = flightsSequencies.find(x3 => x3.flights[0].remotePriceSource.flightId === x2)
                group.push(flight)
            })
            mutateToFlightsSequencies.push({
                ...group[0],
                group
            })
        })

        // console.log(mutateToFlightsSequencies, 111);

        let list = [];
        if (page === 1) {
            list = mutateToFlightsSequencies.slice(0, 20);
        } else {
            list = mutateToFlightsSequencies.slice((page-1) * 20, page * 20)
        }
        return new Promise((resolve) => {
            resolve({
                list: list,
                paginationLength: Math.ceil(mutateToFlightsSequencies.length / 20)
            })
        })
    },
    [types.A_GET_GDS_FLIGHT] ( context, payload ) {
        context.commit(mutation_types.M_SET_GDS_PARAM, payload);
        return new Promise((resolve, reject) => {
            Vue.Api.Post(`${context.state.API_URL}GetGDSFlights`, payload)
                .then(res => {
            // const res = JSON.parse(gds)
            // console.log(res, 333);
            if(res.data.flightsSequencies === null){
                reject(res)
            }
            context.state.GDSData = Object.assign({}, payload);
            if (!res.data.flightsSequencies) {
                context.state.flightsSequencies = [];
                context.state.resultCount = 0
            } else {
                context.state.flightsSequencies = [];

                res.data.flightsSequencies.forEach(x => {
                    x.price = x.deltaPrice.amount;
                    x.hasLuggage = context.getters['getLuggage'](x);
                    x.timeLimit = x.flights[0].segments[0].timeLimit;

                    const index = context.state.flightsSequencies.map(x2 => x2[0].price).indexOf(x.price);
                    if (index !== -1) {
                        context.state.flightsSequencies[index].push(x)
                    } else {
                        context.state.flightsSequencies.push([x])
                    }
                    return x
                });

                context.state.flightsSequencies = res.data.flightsSequencies.map(x => {
                    x.price = x.deltaPrice.amount;
                    x.hasLuggage = context.getters['getLuggage'](x);
                    x.timeLimit = x.flights[0].segments[0].timeLimit;
                    return x
                });
                context.state.resultCount = context.state.flightsSequencies.length;
            }

            if (context.state.saveParams) {
                this.dispatch("basket/A_GET_FLIGHTS_SEQUENCIES", {params: context.state.saveParams})
                    .then(res => {
                        resolve(res)
                    });
                return
            }
            resolve(res.data)
            })
            .catch(err => {
                reject(err);
            })
        });
    },
    [types.A_GET_TARIFF] ( context, payload ) {
        let sendParams = {...payload};
        sendParams.param = context.getters['getGDSParam'];
        sendParams.passengers = [...sendParams.param.passengers];

        const data = {
            params: sendParams,
            API_URL: `${context.state.API_URL}GetGDSFlightFareFamilies`
        };
        return new Promise((resolve, reject) => {
            GDSTariff(data).then(res => {
                if (res.data.validationResult.IsValid && res.data.tariffSequencies.length) {
                    resolve(res)
                } else {
                    reject(res)
                }
            })
        })
    },
    [types.A_REBUILD_FLIGHT] ( context, payload ) {
        const data = {
            params: payload,
            API_URL: `${context.state.API_URL}RebuildFlights`
        };
        return new Promise((resolve) => {
            RebuildFlight(data).then(res => {
                resolve(res)
            })
        })
    },
    [types.A_SET_API_URL] ( context, payload ) {
        context.commit(mutation_types.M_SET_API_URL, payload)
    },
    [types.A_SET_API_ORIGIN] ( context, payload ) {
        context.commit(mutation_types.M_SET_API_ORIGIN, payload)
    },
    [types.A_ADDITIONAL_FLIGHT_SERVICES] ( context, payload ) {
        return new Promise((resolve, reject) => {
            Vue.Api.Post(`${context.state.API_URL}GetFlightsAdditionalServices`, payload)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                })
        });
    },
    [types.A_CALCULATE_INDIVIDUAL_SERVICE_COST] ( context, payload ) {
        return new Promise((resolve) => {
            Vue.Api.Post(`${context.state.API_URL}CalculateIndividualServiceCosts`, payload)
                .then(res => {
                    resolve(res.data)
                });
        });
    },
    [types.A_GET_USER_ALL_INFO] ( context, payload ) {
        const date = new Date().getTime();

        return new Promise((resolve) => {
            Vue.Api.Get(`${context.state.API_URL}Client?clientId=${payload}&_=${date}`)
                .then(res => {
                    resolve(res.data)
                });
        });
    },
    [types.A_GET_HOTELS_FOR_MAP](context, payload) {
        const _this = this;


        let data = payload.split("?")[1].split("&");

        let currencyIsoCode = data.find(x => x.includes("currency")).split("=")[1];
        let currency = this.getters['getCurrency'].find(x => x.IsoCode === currencyIsoCode).Code

        const dCity = data.find(x => x.includes("departureCities")).split("=")[1];
        const destType = data.find(x => x.includes("destination")).split("=")[1].split("_")[0];
        const destanation = data.find(x => x.includes("destination")).split("=")[1].split("_")[1];
        const dates = data.find(x => x.includes("date")).split("=")[1];
        const durations = data.find(x => x.includes("duration")).split("=")[1];
        const adult = data.find(x => x.includes("adultCount")).split("=")[1];
        let childrens = data.find(x => x.includes("childAges"));
        childrens = childrens ? childrens.split("=")[1].split(",") : null;
        const hotelQ = data.find(x => x.includes("hotelQuota"))?.split("=")[1];
        const aviaQ = data.find(x => x.includes("aviaQuota")).split("=")[1];
        const busQ = data.find(x => x.includes("busTransferQuota"))?.split("=")[1];
        const railwayQ = data.find(x => x.includes("trainTransferQuota"))?.split("=")[1];
        const date = new Date().getTime();

        let sendParams = `${context.state.API_URL}TourForWeb/search/map?` +
            `DepartureCityKeys=${dCity}&` +
            `Dates=${dates}&` +
            `Durations=${durations}&` +
            `Groups=32&` +
            `PageNumber=1&` +
            `PageSize=20&` +
            `HotelScheme=&` +
            `TourKey=&` +
            `TourDuration=&` +
            `ShowToursWithoutHotels=-1&` +
            `IsFromBasket=true&` +
            `isFillSecondaryFilters=false&` +
            `DestinationType=${destType}&` +
            `DestinationKey=${destanation}&` +
            `AdultCount=${adult}&` +
            (childrens ? childrens.map(x => `ChildAges=${x}&`).join("") : "") +
            `CurrencyName=${currency}&` +
            `HotelQuota=${hotelQ}&` +
            `AviaQuota=${aviaQ}&` +
            `BusTransferQuota=${busQ}&` +
            `RailwayTransferQuota=${railwayQ}&` +
            `TourType=-1&` +
            `CityIds=-1&` +
            `TimeDepartureFrom=00:00&` +
            `TimeDepartureTo=23:59&` +
            `TimeArrivalFrom=00:00&` +
            `TimeArrivalTo=23:59&` +
            `SearchMaxPriceAlgoritm=false&` +
            `MatrixAlgoritm=false&` +
            `wrongLicenseFileUpperTitle=Incorrect license file.&` +
            `RemoteHotelMode=0&` +
            `_=${date}`;
        TourSearchForMap(sendParams)
            .then(res => {
                setMapItems(res)
            });

        function setMapItems(res) {
            const date = new Date().getTime();
            let items = [...res.data.SearchForMap];
            const keys = items
                .map(x => x.Services.filter(x => x.SvKey === 3))
                .filter(x => x.length)
                .map(x => x[0].Hotel.Key);

            let hotelKeys = keys.map(x => `hotelKeys=${x}`);
            hotelKeys = new Set(hotelKeys);
            hotelKeys = Array.from(hotelKeys).join("&");

            Vue.Api.Get(context.state.API_URL + `HotelImages?${hotelKeys}&_=${date}`)
                .then(res2 => {
                    items = items.map(x => {
                        const path = _this.getters['getPath'];
                        const hotels = x.Services.find(x2 => x2.SvKey === 3);
                        if (hotels) {
                            const hotelKey = hotels.Hotel.Key;
                            const image = res2.data.find(x2 => x2.HotelKey === hotelKey);

                            x.mainImg = `${context.state.API_ORIGIN}${path}/Image/GetImage?code=${hotelKey}&type=medium&name=${image.Name}&imageType=hotels`;
                        }

                        return x
                    });

                    context.commit(mutation_types.M_SET_HOTELS_FOR_MAP, items)
                });
        }
    },
    [types.A_GET_PROMOCODES] ( context, payload ) {
        const sendParams = `${context.state.API_URL}PromocodesAndDiscounts/GetActiveCauseDiscounts?` +
                           `dateIn="${payload.dateIn}"`;

        return new Promise((resolve, reject) => {
            Vue.Api.Get(sendParams)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    reject(err)
                });
        });
    },
    [types.A_CHECK_PROMOCODE] ( context, payload ) {
        const sendParams = `${context.state.API_URL}PromocodesAndDiscounts/CheckPromocode?` +
                           `promocode=${payload.promocode}&` +
                           `TPKey=${payload.TPKey}&` +
                           `countryKey=${payload.countryKey}`;

        return new Promise((resolve, reject) => {
            Vue.Api.Get(sendParams)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                  reject(err)
              });
        });
    },
    [types.A_CHECK_DISCOUNT] ( context, payload ) {
        const sendParams = `${context.state.API_URL}PromocodesAndDiscounts/CheckCauseDiscount?` +
                           `key=${payload.key}&` +
                           `symbolsNumber=${payload.symbolsNumber}&` +
                           `dateIn="${payload.dateIn}"`;

        return new Promise((resolve, reject) => {
            Vue.Api.Get(sendParams)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                  reject(err)
              });
        });
  },
};
